import { connect } from 'react-redux';
import { getMaterialNames, getProfileTypes, getProfileSizes, getProfileShape, 
  setSpinner as setProfileSpinner} from '@reducers/web-services/profile/actions';
import { setProfileRotateDirection, setProfileRotation } from '@reducers/selectors/application/actions';
import MaterialSelector from './MaterialSelector';
import { setBeamType } from '@reducers/options/beam/actions';
import Beam from '@scene/objects/beam';

const mapState = (state) => {
  let profile = state.selectors.application[state.main.appType].profile;
  if (!profile){
    profile = { rotation: 0, rotateDirection: 'right' };
  }
    
  return {
    appType: state.main.appType,
    beamType: state.options.beam.type,
    materialNames: state.webServices.profile.materialNames || [],
    profileTypes: state.webServices.profile.profileTypes || [],
    profileSizes: state.webServices.profile.profileSizes || [],
    profileRotation: profile.rotation,
    profileRotateDirection: profile.rotateDirection,
    isPending: state.webServices.profile.isPending,
    predefinedBasePlate: state.selectors.application[state.main.appType].predefinedBasePlate || false
  };
};

const mapDispatch = dispatch => ({
  getMaterialNames: () => dispatch(getMaterialNames()),
  getProfileTypes: () => dispatch(getProfileTypes()),
  getProfileSizes: (profileType) => dispatch(getProfileSizes(profileType)),
  getProfileShape: (family, size) => dispatch(getProfileShape(family, size)),

  setProfileRotation: value => dispatch(setProfileRotation(value)),
  setRotateDirection: value => dispatch(setProfileRotateDirection(value)),

  deleteProfile: () => dispatch(setBeamType(Beam.types.NONE)),

  setSpinner: (value) => dispatch(setProfileSpinner(value))
});

export default connect(mapState, mapDispatch)(MaterialSelector);



// WEBPACK FOOTER //
// ./src/components/MaterialSelector/index.js